import React from "react";
import "../ViewHistoricalData.css";
import useAirlineAdminApi from "../../../../../services/api/useAirlineAdminApi";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../../../../components/element/Loader";
import { formatToTwoDecimal } from "../../../../../utils/utils";
import { useFormData } from "../../../../../helpers/FormDataProvider";

const ViewHistoricalDataPaymentSummary = ({ flightPlanDetail }) => {
  const { userData } = useFormData();
  const { fetchCommercialFlightPlanFee } = useAirlineAdminApi(
    userData.isAAUser
  );

  const { data: flightPlanFeeData, isLoading } = useQuery({
    queryKey: ["get-commercial-flight-plan-fee", flightPlanDetail?.id],
    queryFn: () => fetchCommercialFlightPlanFee(flightPlanDetail?.id),
    enabled: !!flightPlanDetail?.id,
  });

  return (
    <div className="view-historical-data-details-sub-container">
      {isLoading ? (
        <Loader />
      ) : (
        
        flightPlanFeeData?.data &&
        flightPlanFeeData?.data?.totalFee > 0 && (
          <div className="view-historical-data-payment-summary-container">
            <div className="view-historical-data-payment-summary-header">
              Payment Summary
            </div>
            <div>
              {flightPlanFeeData?.data?.scannedPassengerSecurityFee > 0 && (
                <div className="view-historical-data-payment-row">
                  <div className="view-historical-data-payment-row-container">
                    <div className="view-historical-data-payment-description">
                      <h3>Security Fees</h3>
                    </div>
                    <div className="view-historical-data-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.scannedPassengerSecurityFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              {flightPlanFeeData?.data?.landingFee > 0 && (
                <div className="view-historical-data-payment-row">
                  <div className="view-historical-data-payment-row-container">
                    <div className="view-historical-data-payment-description">
                      <h3>Landing Fees</h3>
                    </div>
                    <div className="view-historical-data-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.landingFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              {flightPlanFeeData?.data?.parkingFee > 0 && (
                <div className="view-historical-data-payment-row">
                  <div className="view-historical-data-payment-row-container">
                    <div className="view-historical-data-payment-description">
                      <h3>Parking Fees</h3>
                    </div>
                    <div className="view-historical-data-payment-amount">
                      <h3>{`BSD ${formatToTwoDecimal(
                        flightPlanFeeData?.data?.parkingFee
                      )}`}</h3>
                    </div>
                  </div>
                </div>
              )}

              <div className="view-historical-data-payment-row">
                <div className="view-historical-data-payment-row-container">
                  <div className="view-historical-data-payment-description">
                    <h3>VAT</h3>
                  </div>
                  <div className="view-historical-data-payment-amount">
                    <h3>{`BSD ${formatToTwoDecimal(
                      flightPlanFeeData?.data?.tax
                    )}`}</h3>
                  </div>
                </div>
              </div>

              <div className="view-historical-data-payment-row view-historical-data-payment-total-row">
                <div className="view-historical-data-payment-row-container">
                  <div className="view-historical-data-payment-description">
                    <h3>Total</h3>
                  </div>
                  <div className="view-historical-data-payment-amount">
                    <h3>{`BSD ${formatToTwoDecimal(
                      flightPlanFeeData?.data?.totalFee +
                        flightPlanFeeData?.data?.tax
                    )}`}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ViewHistoricalDataPaymentSummary;
